/** @jsx dom */
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import {InputField} from '@viskan/deku-form';

const propTypes = {
	getTranslation: {
		source: 'getTranslation'
	},
	validationError: {
		source: 'validationError'
	},
	openPopup: {
		source: 'openPopup'
	},
	site: {
		source: 'site'
	}
};

const initialState = () => ({
	isAutoFilled: undefined,
	isFocused: undefined,
	value: undefined
});

const afterMount = (component, el, setState) => {
	const setStateValue = event => {
		if (event.animationName === 'onAutoFillStart') {
			setState({isAutoFilled: true});
		} else if (event.animationName === 'onAutoFillCancel') {
			setState({isAutoFilled: false});
		}
	};

	el.addEventListener('animationstart', setStateValue, false);
	el.querySelectorAll('input').forEach(input => input.addEventListener('animationstart', setStateValue, false));
};

const focusId = id => () => document.getElementById(id).focus();

const shouldUpdate = ({props, state}, nextProps, nextState) => !deepEqual(props, nextProps) || !deepEqual(state, nextState);

const render = ({props, state}, setState) => {
	const {label, name, type = 'text', required, rules} = props;
	const isChanged = typeof state.value === 'string';
	const currentValue = isChanged ? state.value : props.value;
	const setStateValue = event => setState({value: event.target.value});
	const onBlur = event => setState({
		isFocused: false,
		value: event.target.value
	});
	const onFocus = event => setState({
		isFocused: true,
		value: event.target.value
	});

	return (
		<div class='VcoCustomer-group' onClick={focusId(name)}>
			<InputField
				key={name}
				class={['VcoCustomer-container', state.isFocused && 'isFocused', currentValue.length > 0 && 'isEntered', state.isAutoFilled && 'isAutoFilled']}
				id={name}
				rules={rules}
				type={type}
				name={name}
				label={label}
				value={props.value}
				validationMessage={props.validationError(label, props.getTranslation)}
				required={required}
				validate={['onBlur']}
				onBlur={onBlur}
				onChange={setStateValue}
				onFocus={onFocus}
				onInput={setStateValue}
			/>
		</div>
	);
}
;
export default {afterMount, initialState, propTypes, render, shouldUpdate};
